import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppSharedModule } from '../shared';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { UserModule } from '../users/user.module';
import { NgxUploaderCompatModule } from 'src/app/_services/primeng-uploader';
import { EcplDocumentExplorerModule } from 'src/app/shared/ecpl-document-explorer';
import { EcplTabNavigationModule } from 'src/app/shared/ecpl-tab-navigation';
import { KubaExportModule } from '../shared/kuba-exports/kuba-export.module';
import { BuinessLicenseAgreementListComponent } from './components/business-license-agreement-list';
import { LicenseAgreementComponent } from './license-agreement.component';
import { BusinessFeatureListResolver, BusinessListResolver } from './services/license-agreement.resolver';
import { LicenseAgreementServices } from './services/license-agreement.service';
import { RowStatusPipe, MonthPipe, LicenseCategoryPipe } from 'src/app/_helpers/pipes';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DatePickerModule } from 'primeng/datepicker';
import { EditorModule } from 'primeng/editor';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MenuModule } from 'primeng/menu';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@NgModule(
    { exports: [
        BuinessLicenseAgreementListComponent,
        LicenseAgreementComponent
    ],
    declarations: [
        BuinessLicenseAgreementListComponent,
        LicenseAgreementComponent
    ],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            RouterModule,
            AppSharedModule,
            TranslatePipe, TranslateDirective,
            UserModule,
            ConfirmDialogModule,
        DatePickerModule,
            EditorModule,
            ContextMenuModule,
            MenuModule,
        SelectModule,
        TextareaModule,
            InputTextModule,
            TranslatePipe, TranslateDirective,
            RouterModule,
            ButtonModule,
        TabsModule,
            NgxUploaderCompatModule,
        ToggleSwitchModule,
            EcplDocumentExplorerModule,
            EcplTabNavigationModule,
            KubaExportModule
        ],
        providers: [
            LicenseAgreementServices,
            BusinessListResolver,
            RowStatusPipe,
            MonthPipe,
            LicenseCategoryPipe,
            BusinessFeatureListResolver,
        provideHttpClient(withInterceptorsFromDi())
        ]

    }
)

export class LicenseAgreementModule { }
